import React, { Fragment, useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';
import { scrollToTop } from '../../../shared/utils/smartutils';

const SmartIcon = (props) => {
  const { t, iconChangeHandler, data, icon, meta } = props;
  const [backgroundIcon, setBackgroundIcon] = useState({});
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleChange = (value) => {
    setBackgroundIcon(value);
    iconChangeHandler(value);
    toggleModal();
  };

  useEffect(() => {
    setBackgroundIcon(icon);
  }, [icon]);

  return (
    <Fragment>
      <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above d-flex justify-content-center">
        {meta.touched && meta.error && (
          <span className="form__form-group-error">
            {meta.error}
            {scrollToTop()}
          </span>
        )}
        <Avatar
          size="90"
          round="50%"
          className="cursor-pointer"
          src={backgroundIcon.link}
          onClick={toggleModal}
        />
      </div>
      <Modal isOpen={modal} className="smart-avatar-modal">
        <ModalHeader toggle={toggleModal}>
          {t('mnt_tablet-items.icon-select-tablet')}
        </ModalHeader>
        <ModalBody>
          <div className="modal-content-icon">
            {data.map((icn) => (
              <Avatar
                key={icn.id}
                size="90"
                round="50%"
                className="cursor-pointer"
                src={icn.link}
                onClick={() => handleChange(icn)}
              />
            ))}
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

SmartIcon.propTypes = {
  t: PropTypes.func.isRequired,
  iconChangeHandler: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      link: PropTypes.string,
    })
  ).isRequired,
  icon: PropTypes.shape({
    id: PropTypes.number,
    link: PropTypes.string,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

SmartIcon.defaultProps = {
  meta: {
    touched: false,
    error: '',
  },
  icon: {
    id: 0,
    link: '',
  },
};

export default withTranslation('common')(SmartIcon);
